<span class="spinner"
      [style.width.px]="sizeData.size" [style.height.px]="sizeData.size"
      [style.border]="sizeData.radius + 'px solid var(--orange-500)'"
      [style.border-radius.%]="50"
      [style.border-bottom-color]="'transparent'"
>
</span>